import type { BrandSpecimen, ModulePreview as Preview } from '../model/module-report-types';

/**
 * The module's preview in a sheet's side column. Only Branding has one today:
 * a small brand card drawn WITH the values Veevart 2.0 holds — button colour,
 * corner radius, typeface — so a reader sees the brand rather than reading hex
 * codes. Only for a record the run migrated, and never with a Salesforce value
 * V2 did not take (`brandingSpecimen`). The colours are validated `#RRGGBB`.
 */
function BrandSpecimenCard({ specimen }: { specimen: BrandSpecimen }) {
    const radius = `${String(specimen.radiusPx)}px`;
    const font = specimen.fontFamily ?? undefined;
    return (
        <div className="grid gap-3">
            <h4 className="text-[12px] font-semibold uppercase tracking-wider text-content-muted">
                Brand in Veevart 2.0
            </h4>
            <div
                className="grid gap-3.5 border border-line bg-surface p-[18px] text-content"
                style={{ borderRadius: radius }}
            >
                <div className="grid gap-0.5">
                    <span
                        className="text-[20px] font-bold tracking-tight"
                        style={{ fontFamily: font }}
                    >
                        {specimen.name}
                    </span>
                    {/* Named, because the device may not have the typeface to draw it. */}
                    <span className="text-[12px] text-content-muted">
                        {specimen.typeface ?? 'Default typeface'}
                    </span>
                </div>
                <div className="flex flex-wrap gap-2">
                    <span
                        className="bg-content px-4 py-2 text-[14px] font-bold text-surface"
                        style={{
                            fontFamily: font,
                            borderRadius: radius,
                            ...(specimen.buttonColor === null
                                ? {}
                                : {
                                      backgroundColor: specimen.buttonColor,
                                      color: specimen.buttonText,
                                  }),
                        }}
                    >
                        Buy tickets
                    </span>
                    <span
                        className="border border-content px-4 py-2 text-[14px] font-bold"
                        style={{
                            fontFamily: font,
                            borderRadius: radius,
                            ...(specimen.buttonColor === null
                                ? {}
                                : {
                                      borderColor: specimen.buttonColor,
                                      color: specimen.buttonColor,
                                  }),
                        }}
                    >
                        Become a member
                    </span>
                </div>
            </div>
            <p className="text-[12.5px] text-content-muted">{specimen.caption}</p>
        </div>
    );
}

export function ModulePreview({ preview }: { preview: Preview }) {
    switch (preview.kind) {
        case 'brand':
            return <BrandSpecimenCard specimen={preview} />;
    }
}
